import React, { useState } from "react";
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Security, SecureRoute, LoginCallback } from '@okta/okta-react';
import { Container } from 'semantic-ui-react';
import config from './config';
import MainContent from "./layout/Content/MainContent.component";
import Footer from "./layout/Footer/NttxFooter.component";
import NavBar from "./layout/NavBar/NavBar.component";
import NotificationProvider from "./components/common/notification-provider/NotificationProvider.component"

function Logout() {
  return <div style={{ marginTop: "8rem", textAlign: "center" }}><h6>You have sucessfully logged out</h6></div>
}

function App() {
  const [newReport, setNewReport] = useState(false);
  const [navToStatus, setNavToStatus] = useState(false);
  return (
    <Router>
      <Security {...config.oidc}>
        <NotificationProvider>
          <NavBar openNewReport={setNewReport} navToStatus={setNavToStatus} />
          <Container text style={{ marginTop: "4rem" }}>
            <SecureRoute path="/" exact>
              <MainContent newReport={newReport} setNewReport={setNewReport} navToStatus={navToStatus} setNavToStatus={setNavToStatus} />
            </SecureRoute>
            <Route path="/implicit/callback" component={LoginCallback} />
            <Route path="/logout" component={Logout} />
          </Container>
          <Footer />
        </NotificationProvider>
      </Security>
    </Router>
  );

}

export default App;
